// extracted by mini-css-extract-plugin
module.exports = {"imgPlaceholder":"DramoxImage_imgPlaceholder__2DNuW"};